import {
	IonRow,
	IonCol,
	IonButton,
	IonIcon,
	IonLabel,
	IonModal,
	IonGrid,
	IonList,
	IonListHeader,
} from '@ionic/react';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { setParameter } from '../../actions/setParam';
import Checkbox from '../../components/Checkbox/Checkbox';
// Styling
import classes from './InviteUser.module.css';
// custom components
import isAuthenticated from '../Authentication/Authenticated';
import InviteUserForm from './InviteUserForm';
// icons
import { publish } from '../../actions/publish';
import { useForm } from 'react-hook-form';
import { personAdd } from 'ionicons/icons';
import { useTypedSelector } from '../../reducers';
import { b64EncodeUnicode } from '../../utils/encoding';

const InviteUser: React.FC = (props: any) => {
	const { intl, users } = props;
	const { handleSubmit, control, errors, watch } = useForm();
	const orgId = watch('userOrganization') && watch('userOrganization').value;
	const email = watch('email');
	const isExitingUser = users
		.filter((u: any) => u.status && u.orgId === orgId)
		.map((u: any) => u.username)
		.find((element: any) => element === email);

	const username = useTypedSelector(state => state.accountState.user.username);
	let encodedUser = b64EncodeUnicode(username);

	const spinoutType = useTypedSelector(state => state.versionState.spinoutType) as string;

	const onUpdate = handleSubmit(data => {
		data.firstName =
			data.firstName && typeof data.firstName === 'string' ? data.firstName.trim() : '';
		data.lastName =
			data.lastName && typeof data.lastName === 'string' ? data.lastName.trim() : '';
		data.email = data.email.toLowerCase().trim();

		if (!orgId) {
			console.log('Error: organization id not set');
			return;
		}
		if (isExitingUser) {
			console.log('Error: The user already exists within the organization');
			return;
		}

		const domainUrl = window.location.hostname;

		publish(`microservice/${orgId}/${encodedUser}/inviteUser`, {
			requestId: 'someId',
			data: {
				firstName: data.firstName,
				lastName: data.lastName,
				username: data.email,
				orgId: orgId,
				spinoutType,
				domainUrl,
			},
		});

		if (data.userGroupNames != null && data.userGroupNames.length > 0) {
			let selectedUserGroups: any = data.userGroupNames;
			for (let selectedUserGroup of selectedUserGroups) {
				publish(`microservice/${orgId}/${encodedUser}/updateUserGroupUsers`, {
					requestId: 'updateUserGroupUsers',
					data: {
						userGroupId: selectedUserGroup.value,
						add: [data.email],
					},
				});
			}
		}

		let deviceGroupIds = [];
		let selectedDeviceGroups: any = data.deviceGroupNames || [];
		for (let selectedDeviceGroup of selectedDeviceGroups) {
			deviceGroupIds.push(selectedDeviceGroup.value);
		}
		publish(`microservice/${orgId}/${encodedUser}/updateUserDeviceGroups`, {
			requestId: 'updateUserDeviceGroups',
			data: {
				userId: data.email,
				add: deviceGroupIds,
			},
		});
		props.setParameter(
			'users',
			'USER_INVITED',
			((data.firstName || '') + ' ' + (data.lastName || '')).trim()
		);
		props.onDismiss();
	});

	return (
		<IonModal
			cssClass={classes.addModal}
			isOpen={props.isOpen}
			swipeToClose
			show-backdrop
			onDidDismiss={props.onDismiss}
		>
			<form onSubmit={onUpdate} className={classes.addForm}>
				<IonList>
					<IonListHeader className={classes.modalHeader} lines="none">
						<div className={classes.headerContainer}>
							<IonIcon
								className={classes.headerIcon}
								color="primary"
								size="large"
								icon={personAdd}
							/>
							<IonLabel color="primary" className={classes.headerTitle}>
								{intl.formatMessage({
									id: 'InviteModal.inviteUserTitle',
								})}
							</IonLabel>
						</div>
						<IonLabel className={classes.headerHint}>
							{intl.formatMessage({
								id: 'InviteModal.hintMessage',
							})}
						</IonLabel>
					</IonListHeader>
				</IonList>
				<IonGrid className={classes.modalContent}>
					<IonRow>
						<InviteUserForm
							control={control}
							errors={errors}
							existentUser={isExitingUser}
						/>
					</IonRow>
					{/* <IonRow className={classes.chkRow}>
						<Checkbox
							label={intl.formatMessage({
								id: 'InviteModal.emailCopy',
							})}
							onChange={() => {}}
						/>
					</IonRow> */}
					<IonRow className={classes.btnRow}>
						<IonCol>
							<IonButton
								className={classes.cancelBtn}
								expand="block"
								shape="round"
								size="large"
								fill="outline"
								onClick={props.onDismiss}
							>
								{intl.formatMessage({
									id: 'InviteModal.cancelBtn',
								})}
							</IonButton>
						</IonCol>
						<IonCol className={classes.submitCol}>
							<IonButton
								expand="block"
								shape="round"
								type="submit"
								size="large"
								fill="outline"
							>
								{intl.formatMessage({
									id: 'InviteModal.inviteBtn',
								})}
							</IonButton>
						</IonCol>
					</IonRow>
				</IonGrid>
			</form>
		</IonModal>
	);
};

const mapStateToProps = (state: any) => ({
	client: state.mqttState.client,
	selectedOrganization: state.selectedOrganizationState.organization,
	users: state.usersState.items,
});

export default injectIntl(
	isAuthenticated(connect(mapStateToProps, { setParameter })(InviteUser), 'InviteUser')
);
